import { render, staticRenderFns } from "./travelAgencyDetails.vue?vue&type=template&id=aa85e31c&scoped=true"
import script from "./travelAgencyDetails.vue?vue&type=script&lang=js"
export * from "./travelAgencyDetails.vue?vue&type=script&lang=js"
import style0 from "./travelAgencyDetails.vue?vue&type=style&index=0&id=aa85e31c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa85e31c",
  null
  
)

export default component.exports